<template>
  <TemplateModal
    ref="modal"
    :edit="!create"
    :text="text"
    :send-function="onSave"
    :open-function="onOpen"
    :minimalize="minimalize"
  >
    <BaseInput
      :label="
        localStorage.translations.pages['setting-business_segment']['dialog-add_edit-labels'][
          'nazvanie'
        ]
      "
      v-model="name"
      prepend-inner-icon="mdi-format-list-bulleted"
      :rules="['required', 'max100']"
      :placeholder="
        localStorage.translations.pages['setting-business_segment']['dialog-add_edit-labels'][
          'nazvanie'
        ]
      "
    />
  </TemplateModal>
</template>

<script>
import BaseInput from 'components/base/BaseInput'
import {mapActions, mapGetters} from "vuex";
export default {
  name: 'BusinessSegmentModal',
  components: { BaseInput },
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    create: Boolean,
    minimalize: Boolean,
  },
  data: () => ({
    name: ''
  }),
  computed: {
    ...mapGetters('workBusinessSegment', ['businessSegmentShow', 'businessSegmentAll']),
    businessSegmentPage() {
      return this.$route.name === 'SettingBusinessSegment'
    },
    SalesProjectCreatePage() {
      return this.$route.name === 'SalesProjectCreate'
    },
    t() {
      return this.localStorage.translations.pages['setting-business_segment']
    },
    text() {
      return {
        button: {
          open: this.t['dialog-add_edit-buttons']['dobavit'],
        },
        title: {
          create: this.t['dialog-add_edit']['sozdanie-segmenta-vida-deyatelnosti'],
          edit: this.t['dialog-add_edit']['redaktirovanie-segmenta-vida-deyatelnosti'],
        },
      }
    },
  },
  watch: {
    businessSegmentShow() {
      this.name = this.businessSegmentShow.name
    },
  },
  methods: {
    ...mapActions('workBusinessSegment', [
      'onBusinessSegmentShow',
      'onBusinessSegmentCreate',
      'onBusinessSegmentGrid',
      'onBusinessSegmentUpdate',
      'onBusinessSegmentAll',
    ]),
    onOpen() {
      if (this.$refs.modal && this.$refs.modal.$refs.form)
        this.$refs.modal.$refs.form.resetValidation()
      if (this.create)
        this.name = ''
      else {
        this.onBusinessSegmentShow(this.id)
        this.onBusinessSegmentAll()
      }
    },
    async onSave() {
      if (this.create) {
        let data = {
          name: this.name,
        }
        await this.onBusinessSegmentCreate(data)
          .then(() => {
            if (this.businessSegmentPage) {
              this.onBusinessSegmentGrid({
                limit: this.$route.query.limit,
                page: this.$route.query.page,
              })
            } else {
              this.onBusinessSegmentAll()
            }
          })
      } else {
        let data = {
          id: this.businessSegmentShow.id,
          name: this.name,
        }
        await this.onBusinessSegmentUpdate(data)
          .then(() => {
            if (this.businessSegmentPage) {
              this.onBusinessSegmentGrid({
                limit: this.$route.query.limit,
                page: this.$route.query.page,
              })
            }
          })
      }
    },
  },
}
</script>